module.exports = __webpack_public_path__ + "img/Skirt-Back-B3-Da-Fc-Gc-Ha-Ia.dee69487.png";